import { useRef } from "react";
import { TiPage, TiList, TiListRef } from "@ti/ui-mobile";
import { Auth } from "@/utils/authUtils";
import CreateButton from "./components/CreateButton";
import ListItem from "./components/ListItem";
import { flutterHandle } from "@/utils/nativeUtils";
import { useT } from "@/utils/intlUtils";
import { getAddressList } from "@/services/system";
import { ListContent } from "./styles";
import type { Address } from "@/services/system/type";
import { useCountryEnums } from "@/utils/countryUtils";

export default () => {
  const t = useT();
  const country = useCountryEnums();

  const ref = useRef<TiListRef | null>(null);

  const onRefresh = () => {
    ref.current?.onSearch();
  };

  return (
    <TiPage
      title={t("常用地址管理")}
      extra={
        <Auth authKey="OAM_062501">
          <CreateButton />
        </Auth>
      }
      bodyStyle={{
        backgroundColor: "#F6F6F6",
      }}
      onBack={() => {
        flutterHandle("flutter_back", "refresh");
      }}
    >
      <ListContent>
        <TiList.Select<Address>
          presetItemStyle="card"
          ref={ref}
          rowKey="id"
          request={getAddressList}
          renderItem={(record) => (
            <ListItem record={record} country={country} onRefresh={onRefresh} />
          )}
        />
      </ListContent>
    </TiPage>
  );
};
